import { render } from "./ViewFeedbackPage.vue?vue&type=template&id=d3943724"
import script from "./ViewFeedbackPage.vue?vue&type=script&lang=js"
export * from "./ViewFeedbackPage.vue?vue&type=script&lang=js"
script.render = render

export default script